import { t } from "../constants/i18n";
import type { Lang } from "../constants/i18n";
import "./About.css";

interface AboutProps {
  lang: Lang;
}

const FACTS_EN = [
  { n: "01", text: "every project starts as a question, not a plan" },
  { n: "02", text: "half of these were supposed to take a weekend" },
  { n: "03", text: "documentation exists. it's called the source code" },
  { n: "04", text: "shipping something bad is better than perfecting nothing" },
];

const FACTS_JP = [
  { n: "01", text: "すべてのプロジェクトは計画ではなく、問いから始まる" },
  { n: "02", text: "これの半分は週末で終わるはずだった" },
  { n: "03", text: "ドキュメントはある。ソースコードという名前で" },
  { n: "04", text: "ひどいものを出す方が、何も完成させないよりマシ" },
];

export default function About({ lang }: AboutProps) {
  const facts = lang === "jp" ? FACTS_JP : FACTS_EN;

  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container">
          <h1 className="about-title">{t(lang, "about_title")}</h1>
          <p className="about-lead">{t(lang, "about_p1")}</p>
        </div>
      </div>

      <div className="about-body">
        <div className="container">
          <div className="about-grid">
            {facts.map((f) => (
              <div className="about-fact" key={f.n}>
                <span className="about-fact-num">{f.n}</span>
                <p className="about-fact-text">{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
